import { Checkbox as NDSCheckbox } from "@narmi/design_system";
import { Control, Controller, FieldValues, Path } from "react-hook-form";
import styles from "./Checkbox.module.css";

interface CheckboxProps<T extends FieldValues> {
  control: Control<T, unknown>;
  name: Path<T>;
  label: string;
}

function Checkbox<T extends FieldValues>(props: CheckboxProps<T>) {
  return (
    <Controller
      name={props.name}
      control={props.control}
      render={function ({ field: { onChange, value }, fieldState: { error } }) {
        return (
          <div className={styles.checkbox}>
            <NDSCheckbox
              checked={Boolean(value)}
              onChange={() => {
                onChange(!value);
              }}
              label={props.label}
              error={error?.message}
            />
          </div>
        );
      }}
    />
  );
}

export { Checkbox };
